import React from 'react';

function ServicesAbout() {
    return (
        <>
            <section className="appie-services-2-area bg-light pt-90 pb-55" id="service">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Why choose us?</h3>
                                <p>
                                    When you choose our company, you can trust that you are
                                    partnering with a reliable and experienced team that is
                                    dedicated to your success
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-tv"></i>
                                </div>
                                <h4 className="title">User Experience</h4>
                                <p>
                                    We focus on designing solutions that are intuitive, easy to use,
                                    and require minimal training.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-sack-dollar"></i>
                                </div>
                                <h4 className="title">Value for Money</h4>
                                <p>
                                    We believe in delivering value for money to our clients, and we
                                    offer competitive pricing for our products and services.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-headset"></i>
                                </div>
                                <h4 className="title">Customer Support</h4>
                                <p>
                                    We offer comprehensive training, support, and ongoing
                                    maintenance to ensure that our clients get the most out of our
                                    solutions.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-4 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-microchip"></i>
                                </div>
                                <h4 className="title">Cutting-Edge Technology</h4>
                                <p>
                                    We stay up-to-date with the latest technology trends and
                                    developments in the hospitality industry, so we can offer our
                                    clients the most cutting-edge solutions available.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-5 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-lightbulb"></i>
                                </div>
                                <h4 className="title">Experience</h4>
                                <p>
                                    With over 7 years of experience in developing business software
                                    solutions, we have the expertise and knowledge needed to deliver
                                    high-quality, effective solutions to our clients.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-6 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-user-tie"></i>
                                </div>
                                <h4 className="title">Customer Satisfaction</h4>
                                <p>
                                    We are committed to providing exceptional customer service and
                                    building long-term partnerships with our clients.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesAbout;
